module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#chapter_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Humpty Dumpty")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph"
  }, [_c('p', {
    staticClass: "chapterEpigraphText"
  }, [_vm._v("“When I use a word,” Humpty Dumpty said in rather a scornful tone, “it means just what I choose it to mean—neither more nor less.”")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphText"
  }, [_vm._v("     “The question is,” said Alice, “whether you can make words mean different things.”")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource"
  }, [_vm._v("Lewis Carroll in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Through the Looking-Glass")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“T")])]), _vm._v("erri wasn’t dying. She was cognitively disabled. It was needless. It was senseless. There was no reason to do this to my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("These words were quietly spoken by Bobby Schindler Jr., the brother of Terri Schiavo, whose sensationalized case about the removal of feeding tubes generated headlines around the world. I met with Bobby in December 2007 as part of my quest to make sense of what happened to the three nurses from my hospital—Amy Gleason, Olga Vasquez, and Kim Hoy—because I thought his perspective might be illuminating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("I found Bobby in Toronto, where he was the keynote speaker "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("at an anti-euthanasia symposium. Accompanied by his longtime friend, Brother Paul O’Donnell from the Franciscan Brothers of Peace, Bobby explained to me that Terri was a cognitively disabled woman who was neither terminally ill nor even calamitously sick. The two men nodded in unison and agreed that she died from “euthanasia by omission.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("We were sitting in the lobby of the Toronto airport hotel, and there was a hint of apprehension as a snowstorm outside began to strengthen and people wondered whether they ought to secure earlier flights and get out of town.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Life doesn’t go back to normal after this,” O’Donnell remarked. “There is a battle going on between the culture of life and the culture of death, and God has called upon our community to represent the culture of life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bobby Schindler was patiently sitting across from me, and he appeared unconcerned with the meteorological conditions. He explained, “It seems to be the premise of the other side that the acceptable alternative to human suffering is to kill…and I just don’t go for that. I don’t buy into the whole premise that killing is an acceptable alternative answer for someone who is suffering—whether emotionally or physically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“For those who believe in the whole autonomy thing—that we should be able to decide the manner and place of our death—I don’t think it is for man to really decide when our deaths should occur. Obviously, I believe that we are all made in the image of God, we are children of God, and He is the one who decides when we should leave this earth. It doesn’t change if we become disabled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I look at it as a deliberate killing of a cognitively disabled person who had a family that was more than willing to care for her. I wholeheartedly believe that my sister was killed—killed by the system, killed by [her husband] Michael Schiavo, killed by whomever. She was deliberately and purposely killed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("When you converse with Bobby Schindler, it is obvious that his ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("passion is sincere, as is his devotion to family, religion, and society’s most vulnerable members. Earlier in the day, Bobby’s formal address before hundreds of participants assembled at this Canadian conference had received an enthusiastic standing ovation, but whether or not you agree with the specifics of his point of view, the man’s grief remains painfully raw and his argument is effectively delivered. His position is shared by millions of people from around the world, including the civil libertarian Nat Hentoff, who called Terri Schiavo’s death “the longest public execution in American history.” Similar beliefs are held by former president George W. Bush, who signed into law a resolution to prevent the feeding tube from being withdrawn, and later declared, “I urge all those who honor Terri Schiavo to continue to work to build a culture of life where all Americans are welcomed and valued and protected.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Although there are notable differences between the case involving the Baystate nurses and that of Terri Schiavo, Bobby Schindler mainly focused his comments to me on what he perceived to be their commonalities. In particular, when Bobby spoke about “the other side” and the people “who believe in the whole autonomy thing,” he was talking about hospice and palliative medicine. This is the name of a new subspecialty that includes medical staff, like me, dedicated to the prevention and relief of suffering during catastrophic and life-limiting illness (throughout this book the terms "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("palliative medicine")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("palliative care")]), _vm._v(" will be used interchangeably).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("palliative")]), _vm._v(" first appeared in 1425, and though it was never commonly used, it was resurrected in the middle of the twentieth century to describe a medical approach that rapidly spread from Britain to the rest of the world. Palliative medicine has been proliferating in the United States ever since, progressing to the point that consultation services have been established in most hospitals with more than a fifty-bed capacity and a variety of hospices are available in every community.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Palliative medicine practitioners confidently work under the ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("assumption that over the past three decades a quiet revolution has occurred. They believe that while it was previously considered improper to openly discuss death with patients and families, nowadays physicians and nurses should be required to have such conversations. They believe that our society approves of efforts to limit and curtail suffering—even if such efforts mean that dying will be accelerated. They believe that deaths following administration of analgesic medications and decisions to withhold or withdraw life-sustaining treatments are distinctly different from those that result from euthanasia or murder. They are confident that the procedures employed in palliative care are both ethical and legal.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("According to the World Health Organization, palliative care is “the active total care of patients whose disease is not responsive to curative treatment.” Therapies for these patients may include vigorous attention to symptoms such as nausea and pain, the provision of services at home or in nursing facilities, and psychological counseling for them or their families. Over the past decade, widespread acceptance of palliative medicine has contributed to a dramatic change in how people die. Even in America’s intensive care units—our country’s most medically aggressive settings—more than three-quarters of an estimated 400,000 deaths are now preceded by treatment limitation decisions. In the few short years between 2000 and 2004, the percentage of Medicare decedents enrolled in hospice care increased by 50 percent. In 2005, 1.2 million Americans died while making use of hospice services.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("According to my friend Dr. Steven Miles, a professor of medicine at the Center for Bioethics at the University of Minnesota, fully 85 percent—or approximately 2 million—of the 2.4 million deaths occurring annually in the United States medical system are preceded by a structured decision to limit life-sustaining treatment. These are astonishing numbers. Over the thirty years that I have been practicing medicine, this represents a fundamental change—one that should have resulted in major repercussions.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If the practitioners of palliative medicine are on one side of a debate, then their opponents are people such as Bobby Schindler. For a substantial period of time I was unaware of the power of this other side and ignorant of the negative reactions that palliative medicine elicited from some segments of the general public. It was not until Amy and her colleagues began recounting to me the heretofore hushed-up details of the circumstances surrounding Rosemarie Doherty’s death at Baystate, and not until the media became completely frenzied over Terri Schiavo’s case, that I began to appreciate how situations like these are part of a direct societal reaction to the practice of palliative medicine. This was only reinforced by the tumult surrounding President Obama’s health care reform efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The Schindler-Schiavo family feud is especially instructive because it spotlights specific palliative care practices, such as the withdrawal and withholding of artificial nutrition and hydration (feeding tubes), and the proliferation of advance care directives (living wills, health care proxies) that are tilted toward helping individuals avoid the initiation or extended use of life-extending therapies (ventilators, dialysis, etc.). During and after Terri’s death, the Schindler family has been instrumental in reinvigorating what Wesley Smith, an astute author and attorney, calls “a powerful and diverse strange political bedfellow coalition,” consisting of pro-life groups, the religious right, a few outspoken medical professionals, activists for the poor, segments of the disability community, and elements within the Catholic Church. Although the coalition lacks an agreed-upon name, it is now a vigorous international movement that gathers under a banner proclaiming the paramount importance of the sanctity of life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Activists in this coalition claim that organized medicine has become seduced by death, and some of them—but certainly not all—are steadfastly opposed to every medical decision that accelerates dying, including the withdrawal or withholding of medical technologies, vigorous use of narcotics, and so forth. For many of the religiously motivated members of the coalition—and they ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("constitute the majority—the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pro-life")]), _vm._v(" has now been expanded beyond abortion to encompass the terminus of life and all practices that foreshorten human existence.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Back in 2005, the Schindlers and the coalition proved their ability to influence the governor and legislature of the state of Florida, Congress, and the presidency—even if they could not ultimately prevent Terri Schiavo’s feeding tube from finally being removed. One year after Terri’s death, the efforts of the coalition led twenty-three states to consider fifty-one separate legislative measures to change or nullify the use of advance directives. According to the coalition’s view, these directives are objectionable not only because they make it easier for people to avoid lifesaving therapies but also because they frequently become a means for depressed people to end their lives and thereby passively commit suicide. A year later, twenty-six of the proposed bills were still active and Louisiana had changed its advance directive law, making it more difficult for patients to express preferences to terminate life support treatments.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("The coalition is likely to have more success with three dozen so-called conscience bills pending in eighteen states that offer protection to health care workers who refuse to provide palliative care and thereby accelerate patient deaths. The conscience bills began as statutes to protect health workers from retaliation if they refused to perform abortions, but they evolved into laws allowing pharmacists and pharmacies to refuse to fill prescriptions for birth control or the morning-after pill. Now they are being extended to include medical professionals opposed to withholding or withdrawing artificial nutrition and hydration or performing other acts that may hasten death. State legislatures are building on a foundation of several existing federal laws that protect the conscience rights of health care workers, about which former Health and Human Services secretary Michael Leavitt has said, “Freedom of conscience is not to be surrendered upon issuance of a medical degree. This nation was built ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("on a foundation of free speech. The first principle of free speech is protected conscience.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The coalition has been especially proud of having defeated recent efforts on the part of Vermont and California to legalize physician-assisted dying protocols; successful campaigns have similarly taken place in the United Kingdom and in Canada. While the coalition may be fragmented on some issues, it is united by unshakable antipathy to physician-assisted suicide. Consequently, the coalition is deeply disturbed that in the 2008 election, Washington’s Death with Dignity referendum passed by a margin of 59 percent to 41 percent and Washington thereby became the second state after Oregon to offer terminally ill people the option of physician-assisted deaths. This was rapidly followed by a Montana judge endorsing a right to assisted suicide for a man with terminal cancer, raising the possibility of the practice becoming accepted in yet a third state.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The bioethicist Tom Koch has written in support of the coalition’s efforts, “The unprecedented political involvement…from this perspective [is] wholly appropriate. Where else in a democracy do citizens turn when they believe current policy and law are inappropriate, prejudicial, and unethical? When courts cannot offer redress the logical next step is to seek legislation that will alter the laws in a manner that permits future judicial support.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("To me, the Baystate nurse’s aide Olga Vasquez has come to symbolize the views and suspicions of millions of people like Bobby Schindler and the sanctity of life coalition, who believe only God should make life and death determinations. According to this view the role of medicine is straightforward: combat disease and prolong patient lives to the utmost. As will become apparent, Olga’s colleagues Amy Gleason and Kim Hoy see things quite differently; to them, the amelioration of suffering trumps the artificial extension of life. They maintain it is both logical and compassionate to withhold or withdraw medical therapies while providing vigorous ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("symptom management, even if these actions result in people dying sooner than they would otherwise.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Amy and Kim believe their situation illustrates Clare Boothe Luce’s aphorism “No good deed goes unpunished.” Olga and the district attorney of the Commonwealth of Massachusetts would argue that the two nurses did not perform a good deed: the nurse’s aide and the prosecutors affirm that they were misguided killers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Terri Schiavo died on March 31, 2005. Since then the American public has remained largely unaware that the case’s underlying conflicts continue to be actively contested. For that matter, most health care providers—American and foreign—do not realize a backlash is occurring against palliative medicine and its underlying philosophy. I have come to think of the Schiavo case as palliative medicine’s Humpty Dumpty—irrevocably shattering the illusion that there is a societal consensus on end-of-life care. As Lewis Carroll declaimed in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Through the Looking-Glass")]), _vm._v(", we are now grappling over the use and meaning of highly charged words—we are struggling in the context of catastrophic and terminal illnesses to find the possible relevance of words such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("killing")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("murder")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As the details of the Baystate disagreement are made clear, most people who have experienced the American medical system either as patients, family members, or care providers will be stunned to learn that this dispute resulted in a full-fledged criminal investigation. While doctors and nurses are always sensitive to the possibility that conflicts over how they practice medicine can result in civil litigation—malpractice—they remain entirely unappreciative of the fact that what they perceive to be ordinary clinical care can trigger criminal proceedings, including murder and homicide accusations. Most medical professionals are not aware that, without any forewarning, they may find themselves defending their actions and facing the possibility of bankruptcy, imprisonment, and the total obliteration of professional careers.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Some of my palliative care colleagues might have preferred that I not publicize this phenomenon, fearing a potentially chilling effect on the medical specialty. But as I learned about all that had gone on at my hospital, I felt compelled to write about it for the same reason road signs are posted about moose, deer, or other animal crossings—the notices may not always prevent crashes, but they at least heighten awareness and give us a slightly better chance of avoiding collisions. Ultimately, I am convinced that recognition of stories like that of Amy and Kim is the key to helping our society form a more rational response, policy, and practice. For too long, we have all (and I include myself in this) remained ignorant of the philosophical debate that is angrily taking place in our hospitals. It’s time to open our eyes.")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d6fc49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008chapter02.vue
// module id = 78
// module chunks = 0